module.exports = __webpack_public_path__ + "static/media/glyph-logo_May2016.0e84d592.png";


//////////////////
// WEBPACK FOOTER
// ./src/SocialAccounts/glyph-logo_May2016.png
// module id = 138
// module chunks = 0